module.exports = __webpack_public_path__ + "static/media/nodejs.11688a08.svg";